
// import firebase from 'firebase/compat/app';
// import 'firebase/compat/database';

// // Initialize Firebase app
// // const firebaseConfig = {
// //   apiKey: "AIzaSyBvswCh3Pmk2reULqT4aa0b-Hkp7GHWYB8",
// //   authDomain: "play-tube-418206.firebaseapp.com",
// //   projectId: "play-tube-418206",
// //   storageBucket: "play-tube-418206.appspot.com",
// //   messagingSenderId: "179733357122",
// //   appId: "1:179733357122:web:9118ca3cbce424e269c3db",
// //   measurementId: "G-53NDQJLL84"
// // };
// const firebaseConfig = {
//   apiKey: "AIzaSyCcRQ4IM4EMHUnzjnn8thBcPo38Js2-Kf8",
//   authDomain: "playtubedataset.firebaseapp.com",
//   databaseURL: "https://playtubedataset-default-rtdb.firebaseio.com",
//   projectId: "playtubedataset",
//   storageBucket: "playtubedataset.appspot.com",
//   messagingSenderId: "41886107762",
//   appId: "1:41886107762:web:7dee8a4269f1404bbe5aeb"
// };
// firebase.initializeApp(firebaseConfig);

// // Reference to the database
// const databaseRef = firebase.database().ref('path/to/your/data');

// // Function to perform POST request
// const postData = (data) => {

//   console.log("Siya Ram!.....")

//   databaseRef.push(data)
//     .then(() => {
//       console.log('Data posted successfully');
//     })
//     .catch((error) => {
//       console.error('Error posting data:', error);
//     });
// };

// // Function to perform GET request
// const getData = () => {
//   console.log("Siya Ram!.....")

//   databaseRef.once('value')
//     .then((snapshot) => {
//       const data = snapshot.val();
//       console.log('Retrieved data:', data);
//     })
//     .catch((error) => {
//       console.error('Error getting data:', error);
//     });
// };

// // Call the postData function with the data you want to post
// const newData = {
//   key1: 'value1',
//   key2: 'value2',
//   // Add more key-value pairs as needed
// };

// export default {postData, getData};
// // postData(newData);

// // Call the getData function to fetch data
// // getData();









// // import firebase, { initializeApp } from 'firebase/app';
// // import {getStorage} from 'firebase/storage';
// // import {getFirestore} from 'firebase/firestore';




// // const firebaseConfig = {
// //     apiKey: "AIzaSyBvswCh3Pmk2reULqT4aa0b-Hkp7GHWYB8",
// //     authDomain: "play-tube-418206.firebaseapp.com",
// //     projectId: "play-tube-418206",
// //     storageBucket: "play-tube-418206.appspot.com",
// //     messagingSenderId: "179733357122",
// //     appId: "1:179733357122:web:9118ca3cbce424e269c3db",
// //     measurementId: "G-53NDQJLL84"
// //   };



// //   const app = initializeApp(firebaseConfig)
// //   const imgdata = getStorage(app);
// //   const imgtext = getFirestore(app)
// // // firebase.initializeApp(firebaseConfig);


// // export default {imgdata, imgtext};

import { initializeApp } from "firebase/app";
import {getFirestore} from 'firebase/firestore';
import {getAuth} from 'firebase/auth';


const firebaseConfig = {
  apiKey: "AIzaSyCcRQ4IM4EMHUnzjnn8thBcPo38Js2-Kf8",
  authDomain: "playtubedataset.firebaseapp.com",
  databaseURL: "https://playtubedataset-default-rtdb.firebaseio.com",
  projectId: "playtubedataset",
  storageBucket: "playtubedataset.appspot.com",
  messagingSenderId: "41886107762",
  appId: "1:41886107762:web:ba65def930fd15efbe5aeb"
};

// Initialize Firebase
const app = initializeApp(firebaseConfig);

 const fireDb = getFirestore(app);
 const autho = getAuth(app);

export  {autho, fireDb};